module.exports = __webpack_public_path__ + "img/ACTIVE_SESSIONS.50ebd108.svg";